export const sylwiaTrafna = {
    'meta': {
        'title': 'Systemowy terapeuta rodzinny Sylwia Trafna-Jurkiewicz',
        'description': 'Jestem absolwentką studiów magisterskich na Wydziale Psychologii i Pedagogiki UKW w Bydgoszczy na kierunku i specjalizacji pedagogika resocjalizacyjna.'
    },
    'url': {
        'address': '/torun/zespol/terapeuta-rodzinny-sylwia-trafna-jurkiewicz/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/sylwia-trafna-jurkiewicz.webp',
            'width': 150,
            'height': 150,
            'alt': 'Pedagog resocjalizacji, systemowy terapeuta rodzinny w Toruniu Sylwia Trafna-Jurkiewicz'
        }
    }
}